export default "__VITE_ASSET__BsIzeMxI__"